import { render } from "./App.vue?vue&type=template&id=c6f9b9ec"
const script = {}

import exportComponent from "D:\\nodejs\\sws03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__